import { CatalogConnectV2Client } from '@square/dashboard-items-data/clients/catalog-connect-v2';
import CatalogObjectAdapter from '@square/dashboard-items-data/adapters/connect/catalog-object';
export default CatalogObjectAdapter.extend({
  async findAll() {
    const response = await CatalogConnectV2Client.listAuthorizedCustomAttributeDefinitions().then(({
      objects = []
    }) => objects);
    this.set('hasFetchedAll', true);
    return response;
  }
});